module.exports = __webpack_public_path__ + "static/media/foodfun_logo.5f4cd861.png";